import PropTypes from 'prop-types';
import React from 'react';
import NoSSR from 'react-no-ssr';
import { eventPropTypesShape } from '../../Includes/eventsProps';
import { buildImagePath } from '../../JobComponents/Company/Image/logo';
import {
    formatHourInAMPMFormat,
    getDateFromISO,
    getFourDigetYearFromISO,
    getMonthFromISO,
    getUserLocalTimeZone,
} from '../../Utilities/TimeFunctions';
import EventRegisterButtonContainer from '../EventRegisterButton/EventRegisterButtonContainer';

import './InPageEventDetailSection.scss';

export default class InPageEventDetailSection extends React.PureComponent {
    constructor(props) {
        super();
    }

    static propTypes = {
        /**
         * single event data
         */
        event: eventPropTypesShape.isRequired,
        /**
         * whether user is register for the event or not
         */
        isUserRegistered: PropTypes.bool.isRequired,
        /**
         * set userRegistered to true
         */
        setUserAsRegistered: PropTypes.func.isRequired,
    };

    static defaultProps = {
        event: {},
        setUserAsRegistered: () => {},
    };

    render() {
        const { isUserRegistered, setUserAsRegistered, event } = this.props;
        const injectedTransforms = { default: '' };
        const imagePath = buildImagePath(
            '/v1561056921/calendar_image_milywa.svg',
            'default',
            injectedTransforms
        );

        return (
            <div className="component-Events-InPageEventDetailSection">
                <img className="calendar-svg" src={imagePath} />
                <div className="middle-section">
                    <div className="full-date-text-display">{`${getMonthFromISO(
                        event.startTime
                    )} ${getDateFromISO(
                        event.startTime
                    )}, ${getFourDigetYearFromISO(event.startTime)}`}</div>
                    <NoSSR>
                        <div className="event-time-display">{`${formatHourInAMPMFormat(
                            event.startTime
                        )} - ${formatHourInAMPMFormat(
                            event.endTime
                        )} ${getUserLocalTimeZone()}`}</div>
                    </NoSSR>
                </div>
                <div className="inPageEventDetailSection-button">
                    <EventRegisterButtonContainer
                        event={event}
                        isUserRegistered={isUserRegistered}
                        setUserAsRegistered={setUserAsRegistered}
                        isSingleEventPage={true}
                    />
                </div>
            </div>
        );
    }
}
